module.exports = __webpack_public_path__ + "img/screen-normal.1db56c9b.png";